import { Component, OnInit } from '@angular/core';
import { BreakpointService } from './shared/services/breakpoint.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private responsive: BreakpointService) {}

  ngOnInit(): void {
    this.responsive.Size().subscribe();
  }
  title = 'dragonfly';
}
